import { useSelector } from 'react-redux';
import { RootState } from 'store/store';

const useAppSelector = <TSelected extends unknown>(
  selector: (state: RootState) => TSelected,
  equalityFn?: ((left: TSelected, right: TSelected) => boolean) | undefined
): TSelected => useSelector<RootState, TSelected>(selector, equalityFn);

export default useAppSelector;
